export const FirebaseConfig = {
	"projectId": "siete7pty",
	"appId": "1:789699319784:web:e94c36738976358309f65d",
	"databaseURL": "https://siete7pty-default-rtdb.firebaseio.com",
	"storageBucket": "siete7pty.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCLrzWmGmPcGt68t3wUQ2HE7heG8SzPvzM",
	"authDomain": "siete7pty.firebaseapp.com",
	"messagingSenderId": "789699319784",
	"measurementId": "G-ZR0VJNFDD3",
	"projectNumber": "789699319784",
	"version": "2"
};